export const AUDIT_FILTERS = ['resource_id'] as const

export const POINT_TRANSACTION_FILTERS = ['voucher_id', 'campaign_id', 'transaction_type'] as const

export const REDEMPTION_FILTERS = ['customer_id', 'result', 'status'] as const

export const EVENT_FILTERS = ['customer_id', 'category'] as const

export const REWARD_FILTERS = ['reward_type', 'source_campaign_id'] as const

export const EARNING_RULE_FILTERS = ['campaign_id', 'trigger_type', 'active'] as const

export const SEGMENT_FILTERS = ['segment_kind'] as const

export const WEBHOOK_SUBSCRIPTION_FILTERS = ['active'] as const

export const isFilteredBy = <Query extends Record<string, unknown>>(
  query: Query,
  keys: readonly (keyof Query)[],
): boolean => keys.some((key) => query[key] !== undefined)
